// /**
//  * 某某页面
//  * @author: leon
//  * @create: 2018-05-21 10:01
//  */

// import Vue from 'vue';

// const bus = new Vue();

// export default {
//   /**
//    * 注册全局事件
//    * @param eventName 事件名称
//    * @param handler 事件处理函数
//    * @param scope vm对象，一般传this 建议必须要传（页面的this），自动销毁功能
//    * @param once 是否单次注册
//    */
//   on(eventName, handler, scope = null, once = false) {
//     if (once) {
//       bus.$once(eventName, handler);
//       return;
//     }
//     bus.$on(eventName, handler);
//     if (scope) {
//       let originalDestroy = scope.$destroy;
//       scope.$destroy = function () {
//         bus.$off(eventName, handler);
//         originalDestroy.call(this);
//       }
//     }
//   },

//   /**
//    * 触发事件
//    * @param eventName 要触发的事件名称
//    * @param data 事件对象
//    */
//   emit(eventName, data = {}) {
//     bus.$emit(eventName, data);
//   }
// };


const events = {};
export function on(eventName, handler, target = null) {
	if (!events[eventName]) {
		events[eventName] = [];
	}
    console.log('listen ' + eventName + ' event ');
	if (!events[eventName].some(el => el.handler == handler && el.target == target)) {
		events[eventName].push({
			handler,
			target
		});
	}
}
export function off(eventName, handler = null, target = null) {
	if (!events[eventName]) {
		return;
	}
	if (target != null) {
		events[eventName] = events[eventName].filter(el => el.handler != handler && el.target != target)
	} else if (handler != null) {
		events[eventName] = events[eventName].filter(el => el.handler != handler)
	} else {
		delete events[eventName]
	}
} 

export function emit(eventName, args) {
	if (!events[eventName]) {
		return;
	}
	console.log('emit ' + eventName, events[eventName] ? events[eventName].length : 0);
	events[eventName].forEach(el => {
		if (el.target) {
			el.handler.call(el.target, args)
		} else {
			el.handler(args)
		}
	})
}



// WEBPACK FOOTER //
// ./src/store/eventBus.js